import './style.scss';

function ImageContainer({ url, ratio }) {
  return (
    <div className={`component--image-container ${ratio}`} style={{ backgroundImage: `url(${url})` }}></div>
  );
}

export default ImageContainer;
